import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../assets/img/NavbarLogo.png"
import uk from "../../assets/img/flag-icon-uk.png"
import sg from "../../assets/img/flag-icon-sg.png"
// reactstrap components
import {
  Button,
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  uncontrolledDropdown,
  Dropdown,
  NavbarBrand,
  Row,
  Col
} from "reactstrap";
import { GlobalContext } from '../../App.js';
// import { getData } from 'utils/localStorage'
// import lib from "react-notifications";
import { removeData } from "../../utils/localStorage";
import { storeData } from "../../utils/localStorage";
import { LANGUAGE } from "../../constant";
import Annoucement from 'components/Headers/AnnoucementBar';



function IndexNavbar() {
  const globalContext = useContext(GlobalContext);
  // const history = useHistory();
  //const [navbarColor, setNavbarColor] = React.useState("") //React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = useState(false);
  // const [scrollTop, setscrollTop] = useState(0);
  const [showhideNavbar, setshowhideNavbar] = useState("show-navbar");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [navbar, setNavbar] = useState([]);
  const history = useHistory()

  // const [isLoggedIn, setIsLoggedIn] = useState(globalContext.authState.isLoggedIn);



  React.useEffect(() => {
    if (globalContext.commonState.homeheader.navbar) {
      setNavbar(globalContext.commonState.homeheader.navbar);
    }

  }, [globalContext.commonState.homeheader]);


  React.useEffect(() => {
    // const updateNavbarColor = () => {
    //   if (
    //     document.documentElement.scrollTop > 399 ||
    //     document.body.scrollTop > 399
    //   ) {
    //     setNavbarColor("");
    //   } else if (
    //     document.documentElement.scrollTop < 400 ||
    //     document.body.scrollTop < 400
    //   ) {
    //     //setNavbarColor("navbar-transparent");
    //     setNavbarColor("");
    //   }
    // };
    // const showhideNavbar = () => {
    //   console.log('before: ' + scrollTop)
    //   if (scrollTop < (document.body.scrollTop || document.documentElement.scrollTop) && (document.body.scrollTop || document.documentElement.scrollTop) > 0) {
    //     setscrollTop((document.body.scrollTop || document.documentElement.scrollTop))
    //     setshowhideNavbar("d-none");
    //   } else {
    //     setscrollTop((document.body.scrollTop || document.documentElement.scrollTop));
    //     setshowhideNavbar("");
    //   }
    // };
    let navbarheight = document.getElementById('navbarsection');
    document.body.style.paddingTop = navbarheight === null ? 0 + "px" : navbarheight.offsetHeight + "px"

    var prevScrollpos = window.pageYOffset;
    const showhideNavbar = () => {

      document.documentElement.classList.remove("nav-open");
      var currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos || currentScrollPos < 500) {
        setshowhideNavbar("show-navbar");

      } else {
        //setshowhideNavbar("hide-navbar");
        setshowhideNavbar("show-navbar");

      }
      prevScrollpos = currentScrollPos;
    }
    window.addEventListener("scroll", showhideNavbar, { passive: true });
    return function cleanup() {
      window.removeEventListener("scroll", showhideNavbar);
    };
  });

  React.useEffect(() => {
    const resizeListener = () => {
      let navbarheight = document.getElementById('navbarsection');
      document.body.style.paddingTop = navbarheight === null ? 0 + "px" : navbarheight.offsetHeight + "px"
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    }
  }, []);

  // React.useEffect(() => {
  //   //console.log('useEffectLoginStatus: ' + globalContext.authState.isLoggedIn)
  //   if (globalContext.authState.isLoggedIn === false) {
  //     // debugger;
  //     const arnum = getData('arnum');
  //     const email = getData('email');
  //     if (arnum != undefined && arnum != '') {
  //       globalContext.authDispatch({ type: 'SET', payload: { arnum: arnum, email: email } });
  //     }
  //   }
  // }, [globalContext.authState.isLoggedIn]);


  const fnLogOut = async () => {
    globalContext.authDispatch({ type: 'RESET' });
    globalContext.notifications('success', 'Logout Successfully.');
    removeData('session');

    if (window.FB !== undefined) {
      window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          window.FB.logout(function (response) {
            console.log('Facebook logout');
          });
        }
      });
    }
    // <Redirect to="/index" />
    // history.push("/");
    // if (!globalContext.authState.isLoggedIn) {
    //   console.log('!globalContext.authState.isLoggedIn');
    //   return <Redirect to="/" />
    // }
  }

  const changeLanguage = async (lg) => {
    storeData('language', lg);
    window.location.reload();
    var select = document.getElementsByClassName("goog-te-combo")[0];
    select.selectedIndex = 1;
    select.addEventListener("click", function () {
      select.dispatchEvent(new Event("change"));
    });
    select.click();
  }

  const FnReturnHtml = (title, link) => {
    switch (link) {
      case '/our-services': {
        return (
          <React.Fragment>
            <NavItem className="d-block d-sm-none" >
              <NavLink to="/our-services" tag={Link}

                onClick={e => {
                  document.documentElement.classList.remove("nav-open");
                  setCollapseOpen(false);
                }}>
                <b>Our Services</b>
              </NavLink>
            </NavItem>
            <NavItem className="d-none d-md-block d-lg-block d-lg-block">
              <Dropdown onMouseOver={() => setDropdownOpen(true)} onMouseLeave={() => setDropdownOpen(false)} isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                <DropdownToggle
                  caret
                  className="mt-0 mb-0 btn-round btn-mega-menu"
                  data-toggle="dropdown"
                  btn-value="Our Services"
                // onClick={e => { history.push("/our-services") }}
                >
                  Our Services
                  </DropdownToggle>
                <DropdownMenu className="sub-menu-container mega-menu">
                  <Row>
                    {globalContext.commonState.megamenuitems.map((item, key) => (
                      <Col md="4" key={key}>
                        <h5 className="title">
                          {item.svcname}
                        </h5>
                        <ul>
                          {item.subservices.map((item2, key2) => (
                            <NavItem className="span" key={key2}>
                              <DropdownItem>
                                {/* <Link to={item2.prodpageid}>
                                    {item2.subsvcname}
                                  </Link> */}
                                <Link
                                  to={{
                                    pathname: `/${item2.prodpageid}`,
                                    state: { 'title': item2.subsvcname }
                                  }}>{item2.subsvcname}</Link>
                              </DropdownItem>
                            </NavItem>
                          ))
                          }
                        </ul>
                      </Col>
                    ))}

                    {/* <div>
                          <div className="menu-title">Experience the best</div>
                          <div className="menu-content">
                            Experience the bes Experience the bes Experience the bes
                          </div>
                          <div className="menu-link">More Info</div>
                        </div> */}
                  </Row>
                </DropdownMenu>
              </Dropdown>
            </NavItem>
          </React.Fragment>
        )
      }
      default:
        return (
          <NavItem>
            <NavLink
              to={link}
              tag={Link}
              onClick={(e) => {
                document.documentElement.classList.remove("nav-open");
                setCollapseOpen(false);
              }}
            >
              <b>{title}</b>
            </NavLink>
          </NavItem>
        );
    }
  }


  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      {/* <Navbar className={"fixed-top " + navbarColor + showhideNavbar} expand="lg" color="white" */}
      <Navbar
        className={"fixed-top pb-0 " + showhideNavbar}
        expand="lg"
        color="white"
        id="navbarsection"
      >
        <Container style={{ marginTop: "0px" }}>
          <div className="navbar-translate">
            <NavbarBrand
              //href="https://demos.creative-tim.com/now-ui-kit-react/#/index?ref=nukr-index-navbar"
              to="/"
              tag={Link}
              //target="_blank"
              id="navbar-brand"
              style={{
                paddingTop: "0px",
              }}
            >
              <img className="logo" alt="..." src={logo}></img>
            </NavbarBrand>
            {/* <UncontrolledTooltip target="#navbar-brand">
                Designed by Invision. Coded by Creative Tim
              </UncontrolledTooltip> */}
            <div style={{ width: "100%" }}>
              {globalContext.authState.isLoggedIn ? (
                <Link
                  className="bg-white d-lg-none d-xl-none d-md-block d-sm-block pull-right"
                  to={{
                    pathname: "/service-booking",
                    state: { redirect: "FINALIZE" },
                  }}
                >
                  <i
                    className="fa fa-shopping-cart fa-lg text-info"
                    style={{ fontSize: "18px" }}
                  ></i>
                </Link>
              ) : (
                  <button
                    className="btn btn-round btn-info d-lg-none d-xl-none d-md-block d-sm-block pull-right"
                    type="button"
                    onClick={() =>
                      globalContext.headerDispatch({ type: "HEADERLOGIN" })
                    }
                  >
                    <i className="fab now-ui-icons users_circle-08 pr-5"></i>Login
                  </button>
                )}
            </div>

            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              {/* <NavItem className="header-item">
                <div>
                  <p className="experince">Experience the best</p>
                </div>
              </NavItem> 
              <NavItem className="header-item">
                <div
                  style={{
                    display: "grid",
                  }}
                >
                  <p>9:00am-9:00pm</p>
                  <p> Daily</p>
                </div>
              </NavItem>*/}
              <NavItem className="header-item">
                <div
                  style={{
                    display: "grid",
                  }}
                >

                  {/* <p className="text-right">Our Hotline</p> */}
                  <p className="phonenumber">
                    {" "}
                    <span className="description">Our Hotline</span>
                    <a href='tel:02081689818' className="description"> 020 8168 9818</a>
                    <a
                      href={globalContext.commonState.homeheader.whatsapp || "#"}
                      target="_blank"
                      className="pl-5"
                    >
                      <i className="fab fa-whatsapp text-success"></i>
                    </a>
                  </p>
                  <p className="text-left pt-5">8am - 8pm daily</p>
                </div>
              </NavItem>
              {!globalContext.authState.isLoggedIn && (
                <NavItem className="header-item mr-20">
                  <Button
                    className="btn-round"
                    color="info"
                    type="button"
                    onClick={() =>
                      globalContext.headerDispatch({ type: "HEADERLOGIN" })
                    }
                  >
                    <i className="fab now-ui-icons users_circle-08"></i>
                    <p className="login">Login</p>
                  </Button>
                </NavItem>
              )}

              <NavItem className="header-item">
                {globalContext.authState.isLoggedIn && (
                  <div className="pt-20">
                    <Link className="pr-10" to="/my-account/my-profile">
                      <i className="fa fa-user-circle fa-lg text-info"></i> My
                      Account
                    </Link>
                    {/* <span className="pr-10"
                    onClick={() => fnLogOut()
                    }>
                    <i className="fa fa-bell fa-lg text-info"></i>
                  </span> */}
                    <Link
                      className="pr-10"
                      to={{
                        pathname: "/service-booking",
                        state: { redirect: "FINALIZE" },
                      }}
                    >
                      <i className="fa fa-shopping-cart fa-lg text-info"></i>
                    </Link>

                    <Link to="#" onClick={() => fnLogOut()}>
                      <i className="fa fa-sign-out-alt fa-lg text-info"></i>
                    </Link>
                  </div>
                )}
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
        <hr className="navbar-hr"></hr>
        {navbar.length > 0 &&
          <Container className="mt-0 p-0">
            {/* <div className="navbar-translate">
            <NavbarBrand
              to="/" tag={Link}
              id="navbar-brand"
              style={{
                fontWeight: "800"
              }}
            >
              home
              </NavbarBrand>
          </div> */}
            <Collapse
              className="justify-content-center"
              isOpen={collapseOpen}
              navbar
            >
              <Nav navbar>
                {/* <NavItem>
                <NavLink
                  to="/index"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>Home</b>
                </NavLink>
              </NavItem> */}
                {globalContext.authState.isLoggedIn && (
                  <NavItem className="d-lg-none d-xl-none d-sm-block d-md-block">
                    <NavLink
                      to="/my-account/my-profile"
                      tag={Link}
                      onClick={(e) => {
                        document.documentElement.classList.remove("nav-open");
                        setCollapseOpen(false);
                      }}
                    >
                      <b>My Account</b>
                    </NavLink>
                  </NavItem>
                )}

                {navbar &&
                  navbar.length > 0 &&
                  navbar.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {FnReturnHtml(item.title, item.link)}
                      </React.Fragment>
                    )
                  })
                }
                {/* 
              <NavItem>
                <NavLink
                  to="/about-us"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>About us</b>
                </NavLink>
              </NavItem> */}



                {/* <NavItem>
                <NavLink
                  to="/rate"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>Rate</b>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/how-it-works"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>How It Works</b>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/shop"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>shop</b>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/corporate-enquiry"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                   <img style={{ height: "20px" }}
                    alt="..."
                    src={"data:image/png;base64,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"}
                  ></img> 
                  <b>corporate enquiry</b>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/blog"
                  tag={Link}
                  onClick={(e) => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  <b>blog</b>
                </NavLink>
              </NavItem>
               */}
                <NavItem
                  className="d-flex"
                >
                  <NavLink
                    className="mr-0"
                    href="https://www.whissh.com.sg/"
                    onClick={(e) => {
                      document.documentElement.classList.remove("nav-open");
                      setCollapseOpen(false);
                    }}>
                    <img
                      style={{ height: "25px" }}
                      alt="..."
                      src={sg}
                    ></img>
                  </NavLink>
                  <NavLink
                    to="/"
                    tag={Link}
                    className="ml-0"
                    onClick={(e) => {
                      document.documentElement.classList.remove("nav-open");
                      setCollapseOpen(false);
                    }}>
                    <img
                      style={{ height: "25px" }}
                      alt="..."
                      src={uk}
                    ></img>
                  </NavLink>
                </NavItem>
                {/* <NavItem
                  className="d-flex"
                >
                  <NavLink
                    className="mr-0"
                    href="#"
                    onClick={(e) => {
                      document.documentElement.classList.remove("nav-open");
                      setCollapseOpen(false);
                      changeLanguage(LANGUAGE.secondary);
                    }}>
                    <img
                      style={{ height: "25px" }}
                      alt="..."
                      src={uk}
                    ></img>
                  </NavLink>
                  <NavLink
                    href="#"
                    className="ml-0"
                    onClick={(e) => {
                      document.documentElement.classList.remove("nav-open");
                      setCollapseOpen(false);
                      changeLanguage(LANGUAGE.primary);
                    }}>
                    <img
                      style={{ height: "25px" }}
                      alt="..."
                      src={sg}
                    ></img>
                  </NavLink>
                </NavItem> */}
                {globalContext.authState.isLoggedIn && (
                  <NavItem className="d-lg-none d-xl-none d-sm-block d-md-block">
                    <NavLink
                      to="/"
                      tag={Link}
                      onClick={(e) => {
                        document.documentElement.classList.remove("nav-open");
                        setCollapseOpen(false);
                        fnLogOut();
                      }}
                    >
                      <b>Logout</b>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>

            </Collapse>
            
          </Container>
          
        }
       <Annoucement/>
      </Navbar>
      
    </>
  );
}

export default IndexNavbar;
